import { render, staticRenderFns } from "./RelatorioTabela.vue?vue&type=template&id=6222f87e&lang=pug"
import script from "./RelatorioTabela.vue?vue&type=script&lang=js"
export * from "./RelatorioTabela.vue?vue&type=script&lang=js"
import style0 from "./RelatorioTabela.vue?vue&type=style&index=0&id=6222f87e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports